namespace Areas.ContractorPay.Summary{
    "use strict";


    export function goToActions(projectInfoId: number, sharePointLink: string) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    function goToSharePoint(sharePointLink: string) {
        if (sharePointLink != null) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    function goToPIFPAF(projectInfoId: number) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }

}